<template>
  <section>
    <h1>Sorry, we couldn’t find that page</h1>
    <h2>Don’t worry, we’ll help you find what you need.</h2>
    <p>Tell us what happened. Our friendly team will be happy to help you.</p>
    <p><a class="button" role="button" href="/support/contact-us" title="Contact Us">Contact us</a></p>
    <p>We’re sorry for the inconvenience and appreciate your patience.</p>
  </section>
</template>

<script>
import { clearSessionObject } from '@/utils';
import { STORAGE_KEYS } from '@general/js/utils';

export default {
  name: 'NotFound',
  props: {
    isMemberPortal: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.isMemberPortal) {
      // Need to clear some keys that will determine whether membership pages can load or not.
      clearSessionObject(Object.values(STORAGE_KEYS.MEMBERSHIP_STATUS));
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@general/styles/_constants.scss';
@import '@general/styles/_responsive_mixins.scss';
@import '@general/styles/components/_error.scss';
</style>
